import { useLocation, useNavigate } from 'react-router-dom'

import { type InquiryTab, InquiryTabs } from '~/features/inquiry/types/inquiry'

const useInquiryTab = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const pathToTabMap: { [key: string]: InquiryTab } = {
    '/customer-service/faq': InquiryTabs.FAQ,
    '/customer-service/inquiry': InquiryTabs.INQUIRY,
  }

  const getTabFromPathname = (pathname: string): InquiryTab => {
    return pathToTabMap[pathname] || InquiryTabs.FAQ
  }

  const inquiryTab = getTabFromPathname(location.pathname)

  const setInquiryTab = (tab: InquiryTab) => {
    const path =
      tab === InquiryTabs.FAQ
        ? '/customer-service/faq'
        : '/customer-service/inquiry'
    navigate(path)
  }

  return {
    inquiryTab,
    setInquiryTab,
  }
}

export default useInquiryTab
